import { OferecePj } from './../../../ficha-veiculo-pj/models/oferece-pj.interface';
import { take, finalize } from 'rxjs/operators';
import { FichaVeiculoPjService } from './../../../ficha-veiculo-pj/services/ficha-veiculo-pj.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContextSharedService } from '../../../context-shared/context-shared.service';
import { LoginStorage } from '../../../login/login.storage';
import { NovaProposta } from './nova-proposta';
import { TipoSolicitanteEnum } from './quem-solicitou/tipo-solicitante.enum';
import { TipoNegociacaoEnum } from './tipo-operacao/enum/tipo-negociacao.enum';
import { TipoProdutoEnum } from './tipo-operacao/enum/tipo-produto.enum';
import { TipoOperacaoSelecao } from './tipo-operacao/tipo-operacao-selecao';
import { PropostaStateService } from '../../../produtos/shared/states/proposta-state.service';
import { StorageService } from '../../../services/storage/storage.service';
import { TipoVeiculoEnum } from '../../../produtos/shared/enums/tipo-veiculo.enum';
import { ButtonSelectorData } from './button-selector/button-selector-data';
import { OMNI_MAIS_REDIRECT_BASE_URL } from '../../../../environments/environment';

interface ParametrosNovaFichaSelecionados {
  tipoCliente: string;
  tipoOperacao: string;
  produto: string;
  solicitante: string;
}

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css'],
})
export class InicioComponent implements OnInit, OnDestroy {
  dadosOperacao: TipoOperacaoSelecao;
  solicitante: string;
  tipoVeiculo: string;

  public tipoCliente: string;
  public offerPj: OferecePj;
  public loadingOferecePj: boolean = false;
  public shouldShowTipoPessoa: boolean = false;
  public tipoPessoalSelecionado: ButtonSelectorData;
  public tiposPessoas: ButtonSelectorData[];

  public initialTipoPessoa: string;
  public initialTipoProduto: string;
  public initialTipoVeiculo: string;
  public initialSolicitante: string;

  constructor(
    private readonly router: Router,
    private readonly loginStorage: LoginStorage,
    private readonly context: ContextSharedService,
    private readonly state: PropostaStateService,
    private readonly storageService: StorageService,
    private readonly fichaVeiculoPjService: FichaVeiculoPjService
  ) {}

  ngOnInit() {
    this.mapOptionsFromLogin();
    if (this.isLojistaLogado) {
      this.solicitante = TipoSolicitanteEnum.LOJA;
    } else if (this.isOriginador) {
      this.solicitante = TipoSolicitanteEnum.CLIENTE;
    }

    this.storageService.patchLocal({
      lastTimeAProposalStarted: new Date().getTime(),
    });

    this.showPj();
  }

  ngOnDestroy(): void {
    this.loginStorage.clearOptions();
  }

  private mapOptionsFromLogin(): void {
    const options = this.loginStorage.options || [];

    if (!options || !Array.isArray(options) || options.length === 0) {
      return;
    }

    const [rawTipoProduto, rawTipoPessoa, rawTipoVeiculo, rawTypeOption] =
      options;

    if (rawTipoPessoa === '1') {
      this.initialTipoPessoa = 'PF';
    } else if (rawTipoPessoa === '2') {
      this.initialTipoPessoa = 'PJ';
    }

    if (rawTipoProduto) {
      const tipoProdutoUpper = String(rawTipoProduto).toUpperCase();

      if (tipoProdutoUpper === 'REFINANCIAMENTO') {
        this.initialTipoProduto = TipoProdutoEnum.REFINANCIAMENTO;
      } else if (
        tipoProdutoUpper === 'CDC' ||
        tipoProdutoUpper === 'FINANCIAMENTO'
      ) {
        this.initialTipoProduto = TipoProdutoEnum.FINANCIMENTO;
      }
    }

    if (rawTipoVeiculo) {
      const tipoVeiculoUpper = String(rawTipoVeiculo).toUpperCase();

      if (tipoVeiculoUpper.includes('LEVE')) {
        this.initialTipoVeiculo = TipoVeiculoEnum.AUTOMOVEIS;
      } else if (
        tipoVeiculoUpper.includes('PESADO') ||
        tipoVeiculoUpper.includes('PESADOS')
      ) {
        this.initialTipoVeiculo = TipoVeiculoEnum.PESADOS;
      } else if (
        tipoVeiculoUpper.includes('MOTO') ||
        tipoVeiculoUpper.includes('MOTOCICLETAS')
      ) {
        this.initialTipoVeiculo = TipoVeiculoEnum.MOTOCICLETAS;
      }
    }

    if (rawTypeOption) {
      const typeOptionLower = String(rawTypeOption).toLowerCase();
      if (typeOptionLower === 'merchant') {
        this.initialSolicitante = TipoSolicitanteEnum.VENDEDOR;
      } else if (typeOptionLower === 'customer_counter') {
        this.initialSolicitante = TipoSolicitanteEnum.CLIENTE;
      }
    }
  }

  get isLojistaLogado() {
    return this.loginStorage.usuario.isLojista;
  }

  get isOriginador() {
    return (
      this.loginStorage.originator && this.loginStorage.originator.originador
    );
  }

  private get isPesadosBrasilUser(): boolean {
    return Boolean(this.loginStorage.originator?.originador);
  }

  private get isLeadUser(): boolean {
    return Boolean(sessionStorage.getItem('originatorType'));
  }

  private getExpectedSelection(): ParametrosNovaFichaSelecionados | null {
    const isPessoaFisicaSelected = this.tipoCliente === 'PF';
    const isOperationSelected =
      this.dadosOperacao?.tipoProduto === TipoProdutoEnum.FINANCIMENTO
      || this.dadosOperacao?.tipoProduto === TipoProdutoEnum.REFINANCIAMENTO;
    const isProdutoSelecionado = [
      TipoVeiculoEnum.AUTOMOVEIS,
      TipoVeiculoEnum.MOTOCICLETAS,
    ].includes(this.tipoVeiculo);
    const isSolicitanteSelecionado = Boolean(this.solicitante);
    const isExpectedSelection =
      isPessoaFisicaSelected &&
      isOperationSelected &&
      isProdutoSelecionado &&
      isSolicitanteSelecionado;

    if (!isExpectedSelection) {
      return null;
    }

    return {
      tipoCliente: this.tipoCliente,
      tipoOperacao: this.dadosOperacao?.tipoProduto,
      produto: this.tipoVeiculo,
      solicitante: this.solicitante,
    };
  }

  private tryOpenNewOmniApp(): boolean {

    const selectedValues = this.getExpectedSelection();

    if (!selectedValues) {
      return false;
    }
    if (this.isPesadosBrasilUser || this.isLeadUser) {
      return false;
    }

    this.onAcessarNovoOmni(selectedValues);
    return true;
  }

  private onAcessarNovoOmni(selectedValues: ParametrosNovaFichaSelecionados) {
    const login = encodeURIComponent(btoa(this.loginStorage.usuario.login));
    const token = encodeURIComponent(btoa(this.loginStorage.usuario.token));
    const agent = encodeURIComponent(
      btoa(JSON.stringify(this.loginStorage.agente)),
    );
    const tipoCliente = encodeURIComponent(selectedValues.tipoCliente);
    const tipoOperacao = encodeURIComponent(selectedValues.tipoOperacao);
    const produto = encodeURIComponent(selectedValues.produto);
    const solicitante = encodeURIComponent(selectedValues.solicitante);
    const redirectUrl = encodeURIComponent(btoa('/app/rodas/visao-geral'));

    const queryParams = `redirectUrl=${redirectUrl}&tipoCliente=${tipoCliente}&tipoOperacao=${tipoOperacao}&produto=${produto}&solicitante=${solicitante}`;
    const newWindow = window.open(
      `${OMNI_MAIS_REDIRECT_BASE_URL}/auth-redirect/${login}/${token}/${agent}?${queryParams}`,
      '_blank',
      'noopener,noreferrer',
    );
    if (newWindow) {
      newWindow.opener = null;
    }
  }

  onDadosOperacaoChange(event: TipoOperacaoSelecao) {
    this.dadosOperacao = event;
    this.solicitante = this.isOperacaoCdcLoja
      ? TipoSolicitanteEnum.VENDEDOR
      : this.solicitante;
  }

  onTipoVeiculoChange(event) {
    this.tipoVeiculo = event;
    if (this.dadosOperacao.leads) {
      this.dadosOperacao.produto = this.tipoVeiculo;
    }
  }

  onTipoClienteChange(event) {
    this.tipoCliente = undefined;
    setTimeout(() => {
      this.storageService.patchLocal({
        tipoCliente: event === 'PF' ? undefined : 2,
      });
      this.tipoCliente = event;
    });
  }

  onSolicitanteChange(event) {
    this.solicitante = event;
  }

  get isShowTipoVeiculo() {
    return (
      this.dadosOperacao.tipoProduto === TipoProdutoEnum.FINANCIMENTO ||
      this.dadosOperacao.tipoProduto === TipoProdutoEnum.REFINANCIAMENTO
    );
  }

  get isShowSolicitante() {
    return (
      !this.isOriginador &&
      !this.isLojistaLogado &&
      (this.isDadosOperacaoVeiculosValid ||
        this.isDadosOperacaoCreditoPessoalValid)
    );
  }

  get isDadosOperacaoVeiculosValid() {
    return (
      (this.isOperacaoVeiculo && !this.dadosOperacao.leads) ||
      (this.isOperacaoVeiculo &&
        this.dadosOperacao.leads &&
        this.dadosOperacao.produto)
    );
  }

  get isDadosOperacaoCreditoPessoalValid() {
    const valid =
      this.isOperacaoCreditoPessoal &&
      this.dadosOperacao.produto &&
      this.dadosOperacao.operacao;

    if (
      valid &&
      this.dadosOperacao.produto === TipoNegociacaoEnum.DEBITO_AUTOMATICO
    ) {
      return this.dadosOperacao.banco;
    }

    return valid;
  }

  get isOperacaoValid() {
    return (
      (this.isOperacaoCdcLoja ||
        this.isOperacaoMicrocredito ||
        this.isOperacaoCdcPremium) &&
      this.dadosOperacao.operacao
    );
  }

  get isOperacaoVeiculo() {
    return [
      TipoProdutoEnum.FINANCIMENTO,
      TipoProdutoEnum.REFINANCIAMENTO,
    ].includes(this.dadosOperacao.tipoProduto);
  }

  get isTipoVeiculo() {
    return [
      TipoVeiculoEnum.AUTOMOVEIS,
      TipoVeiculoEnum.MOTOCICLETAS,
      TipoVeiculoEnum.PESADOS,
    ].includes(this.tipoVeiculo);
  }

  get isOperacaoCdcLoja() {
    return this.dadosOperacao.tipoProduto === TipoProdutoEnum.CDC_LOJA;
  }

  get isOperacaoCdcPremium() {
    return this.dadosOperacao.tipoProduto === TipoProdutoEnum.CDC_PREMIUM;
  }

  get isOperacaoCreditoPessoal() {
    return this.dadosOperacao.tipoProduto === TipoProdutoEnum.CREDITO_PESSOAL;
  }

  get isOperacaoMicrocredito() {
    return this.dadosOperacao.tipoProduto === TipoProdutoEnum.MICROCREDITO;
  }

  get isNext() {
    return (
      this.solicitante &&
      (this.isOperacaoValid ||
        this.isDadosOperacaoCreditoPessoalValid ||
        this.isDadosOperacaoVeiculosValid)
    );
  }

  onclickNext() {
    if (!this.tryOpenNewOmniApp()) {
      this.onClickNextFichaVeiculo();
    }
  }

  onClickNextFichaVeiculo() {
    this.navigateToNextRouteNavigate();
  }

  navigateToNextRouteNavigate() {
    this.state.clear();
    this.context.set(this.dadosSelecionado);
    this.router.navigate(this.nextRoute);
  }

  get nextRoute() {
    if (this.isOperacaoCdcLoja || this.isOperacaoCdcPremium) {
      return ['produtos/cdcloja/fichas'];
    }

    if (this.isOperacaoCreditoPessoal || this.isOperacaoMicrocredito) {
      return ['produtos/cp/fichas'];
    }

    if (this.isOperacaoVeiculo) {
      const rota =
        this.tipoCliente === 'PJ'
          ? 'nova-ficha-veiculo-pj'
          : 'nova-ficha-veiculo';
      const operacao =
        this.dadosOperacao.tipoProduto === TipoProdutoEnum.FINANCIMENTO
          ? 'financiamento'
          : this.dadosOperacao.tipoProduto;
      if (this.dadosOperacao.leads) {
        return [
          'produtos/leads/nova-ficha-veiculo',
          operacao.toLocaleLowerCase(),
          this.dadosOperacao.produto,
          this.solicitante.toLocaleLowerCase(),
        ];
      }
      return [
        rota,
        operacao.toLocaleLowerCase(),
        this.solicitante.toLocaleLowerCase(),
        this.tipoVeiculo.toLocaleLowerCase(),
      ];
    }

    return ['ficha'];
  }

  get dadosSelecionado(): NovaProposta {
    return {
      solicitante: this.solicitante,
      tipoProduto: this.dadosOperacao.tipoProduto,
      operacao: this.dadosOperacao.operacao,
      produto: this.dadosOperacao.produto,
      banco: this.dadosOperacao.banco,
      parametroRendaProduto: this.dadosOperacao.parametroRendaProduto,
      tipoVeiculo: this.tipoVeiculo,
    };
  }

  get showProdutos(): boolean {
    return this.isCreditoPessoal || this.isVeiculo;
  }

  get isCreditoPessoal(): boolean {
    return [TipoProdutoEnum.CREDITO_PESSOAL].includes(
      this.dadosOperacao.tipoProduto,
    );
  }

  get isVeiculo(): boolean {
    return [
      TipoProdutoEnum.FINANCIMENTO,
      TipoProdutoEnum.REFINANCIAMENTO,
    ].includes(this.dadosOperacao.tipoProduto);
  }

  showPj() {
    this.loadingOferecePj = true;
    this.fichaVeiculoPjService
      .getOffersByPersonType(this.loginStorage.agenteId)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingOferecePj = false;
        }),
      )
      .subscribe(
        (value) => {
          this.offerPj = value;

          if (value.offerPJProposal) {
            this.shouldShowTipoPessoa = value.offerPJProposal;
            this.shouldShowTipoPessoa = true;
            this.tiposPessoas = [
              new ButtonSelectorData('PF', 'Pessoa Física', 'pf', 1, ''),
              new ButtonSelectorData('PJ', 'Pessoa Juridica', 'pj', 1, ''),
            ];
            return;
          }

          const personTypeId =
            this.offerPj && this.offerPj.personType
              ? this.offerPj.personType.id
              : null;

          if (!personTypeId || personTypeId === 1) {
            this.tiposPessoas = [
              new ButtonSelectorData('PF', 'Pessoa Física', 'pf', 1, ''),
            ];
            this.tipoPessoalSelecionado = this.tiposPessoas[0];
            this.onTipoClienteChange('PF');
          } else if (personTypeId === 2) {
            this.tiposPessoas = [
              new ButtonSelectorData('PJ', 'Pessoa Juridica', 'pj', 1, ''),
            ];
            this.tipoPessoalSelecionado = this.tiposPessoas[0];
            this.onTipoClienteChange('PJ');
          } else if (personTypeId === 3) {
            this.tiposPessoas = [
              new ButtonSelectorData('PF', 'Pessoa Física', 'pf', 1, ''),
              new ButtonSelectorData('PJ', 'Pessoa Juridica', 'pj', 1, ''),
            ];
          }
          this.shouldShowTipoPessoa = true;
        },
        (_) => {
          this.shouldShowTipoPessoa = false;
          this.onTipoClienteChange('PF');
        },
      );
  }
}
